import { render } from "./SpendEvolutionCandle.vue?vue&type=template&id=3705cfd0&scoped=true"
import script from "./SpendEvolutionCandle.vue?vue&type=script&lang=js"
export * from "./SpendEvolutionCandle.vue?vue&type=script&lang=js"

import "./SpendEvolutionCandle.vue?vue&type=style&index=0&id=3705cfd0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3705cfd0"]])

export default __exports__